import { ChangeEvent, FormEvent, useState, useEffect } from 'react'
import { IoArrowUpCircleOutline, IoFlameSharp } from 'react-icons/io5'
import { BiSearch } from 'react-icons/bi'
import { Link, useHistory } from 'react-router-dom'

import { useTranslation, useUser } from '../../hooks'
import generateProfilePhotoUrl from '../../lib/profilePhoto'
import pages, { generateUrl } from '../../pages'
import { changeLanguage, languages } from '../../translations/i18n'
import Button from '../Button'
import CachedImage from '../CachedImage'
import MenuItems from '../menuItems'
import Logo from '../Logo'
import SideMenu from '../SideMenu'

import styles from './Header.module.scss'

const Search = (props: any) => {
  const { t } = useTranslation()
  const params = new URLSearchParams(window.location.search)
  const [query, setQuery] = useState(params.get('q') || '')
  const [focussed, setFocussed] = useState(false)
  const history = useHistory()

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()

    if (!query || !query.trim()) return

    history.push(`${pages.search.path}?q=${encodeURIComponent(query)}`)
  }

  const onBlur = () => setFocussed(false)
  const onFocus = () => setFocussed(true)

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value)
  }

  const click_search = () => {
    if (props && props.from === 'phone_search') {
      props.hidePhoneSearch()
    }
  }

  return (
    <form
      onSubmit={onSubmit}
      className={`${styles.search} ${focussed ? styles.focus : ''}`}
    >
      <label htmlFor="search">
        {/* <BiSearch className={styles.pc_img} /> */}

        <img
          className={styles.phone_img}
          onClick={() => click_search()}
          src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1688351795947_Group 634698.png"
          alt=""
        />

        <input
          id="search"
          type="text"
          onChange={onChange}
          value={query}
          placeholder={t('searchPlaceholder')}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      </label>
    </form>
  )
}

const Header = (props: any) => {
  const { t } = useTranslation()
  const { loading, userData, loggedIn } = useUser()
  const [chooseLanguage, setChooseLanguage] = useState<string | null>('English')
  const [showSearch, setShowSearch] = useState<boolean>(false)
  const channelPath =
    loggedIn && userData?.userName
      ? generateUrl(pages.channel.path, { userName: userData?.userName })
      : ''

  const [showPhoneSideMenu, setShowPhoneSideMenu] = useState<boolean>(false)

  useEffect(() => {
    const acquiesceLng = window.localStorage.i18nextLng

    languages.forEach((item) => {
      if (item[0] == acquiesceLng) {
        setChooseLanguage(item[2])
      }
    })
    // init_user()
  }, [])

  // 多语言切换
  const click_multilingual = (item: string[]) => {
    setChooseLanguage(item[2])
    changeLanguage(item[0])
  }

  const go_login = () => {
    props.toLogin()
  }

  const showTips = () => {
    props.showTips()
    setShowPhoneSideMenu(false)
    document.body.style.removeProperty('overflow')
  }
  const showHide = () => {
    setShowPhoneSideMenu(false)
    document.body.style.removeProperty('overflow')
  }

  const getSearchInfo = () => {
    setShowSearch(false)
  }

  return (
    <>
      {/* pc */}
      <div className={styles.header}>
        <div className={styles.left}>
          {/* <SideMenu /> */}
          <Logo />
          <Search />
        </div>
        {!loading && (
          <div className={styles.right}>
            <div className={styles.right_lng}>
              <img
                className={styles.right_lng_img}
                src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687315647089_Language.svg"
                alt=""
              />
              <div className={styles.languages_box_wrap}>
                <ul className={styles.languages_box_hover}>
                  {languages.map((item) => {
                    return (
                      <li
                        className={
                          chooseLanguage == item[2] ? styles.select_li : ''
                        }
                        key={item[2]}
                        value={item[2]}
                        onClick={() => click_multilingual(item)}
                      >
                        {item[2]}
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>

            {loggedIn ? (
              <div className={styles.loggedIn}>
                <Link to={'/upload'} className={styles.upload_link}>
                  <img
                    src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1688708401387_Frame.png"
                    alt=""
                    className={styles.upload_img}
                  />
                  upload
                </Link>
                <CachedImage
                  src={generateProfilePhotoUrl(userData?.profilePhoto)}
                  alt={t('headerMyAccount')}
                />
                {/* <Link
                  to={pages.account.path}
                  title={t('headerMyAccount')}
                  className={styles.account}
                >
                  <CachedImage
                    src={generateProfilePhotoUrl(userData?.profilePhoto)}
                    alt={t('headerMyAccount')}
                  />
                </Link> */}
              </div>
            ) : (
              // <div className={styles.loggedOut}>
              //   <Button small href={pages.login.path} subtle>
              //     {t('headerSignUpOrLogin')}
              //   </Button>
              // </div>
              <div className={styles.loggedOut} onClick={() => go_login()}>
                {t('headerSignUpOrLogin')}
              </div>
            )}
          </div>
        )}
      </div>
      {/* 手机端 */}
      {!showSearch && (
        <div className={styles.header_phone}>
          <img
            onClick={() => {
              setShowPhoneSideMenu(true)
              document.body.style.setProperty('overflow', 'hidden')
            }}
            className={styles.header_phone_img}
            src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1688116871974_Frame.svg"
            alt=""
          />
          <Logo />
          <div className={styles.header_phone_right}>
            <img
              className={styles.common_img}
              onClick={() => {
                setShowSearch(true)
              }}
              src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1688351795947_Group 634698.png"
              alt=""
            />
            <div className={styles.right_lng_phone}>
              <img
                className={styles.right_lng_phone_img}
                src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1688351871164_Frame (1).png"
                alt=""
              />
              <div className={styles.languages_box_wrap}>
                <ul className={styles.languages_box_hover}>
                  {languages.map((item) => {
                    return (
                      <li
                        className={
                          chooseLanguage == item[2] ? styles.select_li : ''
                        }
                        key={item[2]}
                        value={item[2]}
                        onClick={() => click_multilingual(item)}
                      >
                        {item[2]}
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
            {loggedIn ? (
              <div className={styles.loggedIn}>
                <Link to={'/upload'} className={styles.upload_link}>
                  <img
                    src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1688701503385_Frame.svg"
                    alt=""
                    className={styles.common_img}
                  />
                </Link>
                <CachedImage
                  src={generateProfilePhotoUrl(userData?.profilePhoto)}
                  alt={t('headerMyAccount')}
                />
              </div>
            ) : (
              <div className={styles.loggedOut}>
                <Button small href={pages.login.path} subtle>
                  {t('headerSignUpOrLogin')}
                </Button>
              </div>
              // <div className={styles.loggedOut} onClick={() => go_login()}>
              //   {t('headerSignUpOrLogin')}
              // </div>
            )}
          </div>
        </div>
      )}
      {/* 搜索栏 */}
      {showSearch && (
        <div className={styles.header_search_wrap}>
          <img
            className={styles.header_back}
            onClick={() => {
              setShowSearch(false)
            }}
            src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1688375942768_Frame.png"
            alt=""
          />
          <Search from={'phone_search'} hidePhoneSearch={getSearchInfo} />
        </div>
      )}

      {/* 侧边导航栏 */}
      {showPhoneSideMenu && (
        <div className={styles.phone_side_menu}>
          <div className={styles.phone_side_menu_box}>
            <div className={styles.phone_side_menu_head}>
              <img
                onClick={() => {
                  setShowPhoneSideMenu(false)
                  document.body.style.removeProperty('overflow')
                }}
                className={styles.header_phone_img}
                src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1688116871974_Frame.svg"
                alt=""
              />
              <Logo />
            </div>
            <MenuItems from="Header" showTips={showTips} hide={showHide} />
          </div>
        </div>
      )}
      {/* <div className={styles.spacer} /> */}
    </>
  )
}

export default Header
